/**
 * The email address of a Firebase user: the account's own email, or else the first
 * sign-in identity that has one. Accounts created while Firebase allowed multiple
 * accounts per email address can have their address only on an identity.
 * @param {object} user - Firebase user, or its toJSON() form
 * @returns {string|undefined} Email address
 */
function firebaseEmail(user) {
  return (
    user.email || (user.providerData || []).find(info => info?.email)?.email
  );
}

export default firebaseEmail;
